var map = {
	"./Arrow right.svg": 87720,
	"./CrossGray.svg": 28587,
	"./access-time.svg": 78378,
	"./account-circle.svg": 11137,
	"./account-multiple.svg": 25598,
	"./add-big.svg": 54386,
	"./add-photo.svg": 24309,
	"./add-small.svg": 58467,
	"./approved.svg": 17823,
	"./arrow-left.svg": 89321,
	"./arrow-right.svg": 64401,
	"./awaiting.svg": 49940,
	"./blog.svg": 26036,
	"./calendar-alt.svg": 41113,
	"./calendar.svg": 13651,
	"./calendar_helper.svg": 32963,
	"./check_box.svg": 30978,
	"./checked.svg": 48096,
	"./circleDown.svg": 58853,
	"./circleUp.svg": 81962,
	"./cms.svg": 48280,
	"./collapse.svg": 95274,
	"./commissions.svg": 72642,
	"./content_copy.svg": 16480,
	"./copy-duplicate.svg": 88023,
	"./copy.svg": 62462,
	"./customers.svg": 54420,
	"./dashboard.svg": 5330,
	"./delete-active.svg": 97759,
	"./delete-outline.svg": 71917,
	"./delete.svg": 65104,
	"./download-alt.svg": 33542,
	"./download-yellow.svg": 34920,
	"./download-zone.svg": 29932,
	"./download.svg": 10923,
	"./drag-icon.svg": 29342,
	"./dragable-icon.svg": 85617,
	"./drop-down.svg": 58617,
	"./dropdown grey.svg": 67329,
	"./dropdown_arrow.svg": 6694,
	"./edit-outlined.svg": 28935,
	"./edit.svg": 78235,
	"./expand.svg": 23330,
	"./extra.svg": 22797,
	"./file-download.svg": 77236,
	"./folder.svg": 6611,
	"./gift-box.svg": 23821,
	"./import.svg": 65374,
	"./info.svg": 24176,
	"./invoice.svg": 23481,
	"./language.svg": 14893,
	"./location-outline.svg": 2246,
	"./location.svg": 98175,
	"./mail.svg": 61129,
	"./menu.svg": 97335,
	"./orders.svg": 77884,
	"./organizers.svg": 7107,
	"./pdf.svg": 90940,
	"./person.svg": 82675,
	"./plus-button.svg": 23774,
	"./preview.svg": 12079,
	"./promo.svg": 28420,
	"./racefox_check.svg": 28718,
	"./racers.svg": 76848,
	"./races.svg": 97751,
	"./radiobutton_icon.svg": 98754,
	"./red-dot.svg": 3465,
	"./refund.svg": 54497,
	"./refund_check.svg": 6707,
	"./reject.svg": 90760,
	"./report.svg": 73447,
	"./reports.svg": 81262,
	"./resend.svg": 36512,
	"./shopping-cart.svg": 86946,
	"./smallInfo.svg": 11883,
	"./smart_links.svg": 10350,
	"./sport-type.svg": 97329,
	"./support-manager.svg": 56412,
	"./sync.svg": 86115,
	"./system.svg": 51046,
	"./text-format.svg": 62197,
	"./tooltip.svg": 38773,
	"./transaction.svg": 62517,
	"./transactions.svg": 30682,
	"./warning.svg": 21401,
	"./xls.svg": 96625
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 94862;